import React, { lazy } from 'react'
import { CommonLoading } from '@/components/Loading'
import ErrorBoundary from '@/components/ErrorBoundary'

const getRoutes = (lazyLoad: any) => {
  return [
    // {
    //   path: '/home',
    //   name: '首页',
    //   element: lazyLoad('Home')
    // },
    // {
    //   path: '/',
    //   name: '首页',
    //   element: lazyLoad('Home')
    // },
    {
      path: '/',
      name: '设备',
      element: lazyLoad('Device')
    },
    {
      path: '/mine',
      name: '我的',
      children: [
        {
          path: '/mine/mineCenter',
          name: '我的中心',
          element: lazyLoad('Mine')
        },
        {
          path: '/mine/messageCenter',
          name: '消息中心',
          element: lazyLoad('Mine/components/MessageCenter')
        },
       
        {
          path: '/mine/newUserGuide',
          name: '新手指引',
          element: lazyLoad('Mine/components/NewUserGuide')
        },
        {
          path: '/mine/question',
          name: '常见问题',
          element: lazyLoad('Mine/components/Question')
        },
        {
          path: '/mine/about',
          name: '关于',
          element: lazyLoad('Mine/components/About')
        },
        {
          path: '/mine/notice',
          name: '通知设置',
          element: lazyLoad('Mine/components/Notice')
        },
        {
          path: '/mine/userSetting',
          name: '用户设置',
          element: lazyLoad('Mine/components/UserSetting')
        },
        {
          path: '/mine/deleteAccount',
          name: '注销账号',
          element: lazyLoad('Mine/components/DeleteAccount')
        },
      ]
    },
    {
      path: '/account',
      name: '会员账户',
      children: [
        {
          path: '/account/login',
          name: '登录',
          element: lazyLoad('Account/Login')
        },
        {
          path: '/account/privacyPolicy',
          name: '隐私政策',
          element: lazyLoad('Account/Login/components/UserAggrement/index.page')
        },
        
        {
          path: '/account/social-callback',
          name: '第三方登录',
          element: lazyLoad('Account/Login/components/LoginTransfer')
        },
        {
          path: '/account/register',
          name: '注册',
          element: lazyLoad('Account/Register')
        },
        {
          path: '/account/forgetPassword',
          name: '忘记密码',
          element: lazyLoad('Account/ForgetPassword')
        },
      ],
    },
    // {
    //   path: '/dashboard',
    //   name: '统计图表',
    //   element: lazyLoad('Dashboard/template/Hems')
    // },
    {
      path: '/settings',
      name: '设置',
      element: lazyLoad('Settings'),
    },
  
    {
      path: '*',
      name: '404页面',
      element: lazyLoad('NotFound')
    },
   
  ]
}


// 路由懒加载
const lazyLoad = (path: string) => {
    const Comp = lazy(() => import(`../src/pages/${path}`))
    return (
      <ErrorBoundary>
        <React.Suspense
          fallback={
            <div style={{ height: '100vh' }}>
              <CommonLoading text="loading..." />
            </div>
          }
        >
          <Comp />
        </React.Suspense>
      </ErrorBoundary>
    )
}

const currentRouter = getRoutes(lazyLoad)

export default currentRouter
